<bfa-tabs type="underline" [hideTabBarIfOneTab]="true" [custom-classes]="customClasses">
	<ng-container *ngFor="let tab of decompositionTabs; let tabIndex = index">
		<ng-template #tabItem>
			<bfa-tabs [activate-on-mobile]="true">
				<tab-panel tab-title="Table" [templateRef]="table"></tab-panel>
				<tab-panel tab-title="Graph" [templateRef]="graph"></tab-panel>
			</bfa-tabs>
			<ng-template #table>
				<dl-display-table
					[attr.data-cy]="tab?.config?.id + '-table'"
					[id]="tab.config.id"
					class="col-12 col-sm-24"
					[data]="tab"
					[total]="tab.config.id === tabId ? totalPortfolioTab : activeOnlyTab"
					[parentCollapsed]="parentCollapsed[tabIndex]"
					[striped]="true"
				></dl-display-table>
			</ng-template>
			<ng-template #graph>
				<bfa-chart
					type="column"
					name="risk"
					[data]="tab"
					[hasFullHeight]="true"
					class="col-12 col-sm-24"
					[customAttributes]="{ contributionTooltipTabData: tab?.config?.id?.includes('active') ? {} : contributionTabsMapping[tab.config.id + '.contributions'] }"
				>
				</bfa-chart>
			</ng-template>
		</ng-template>
		<tab-panel [tab-title]="tab.config.title.label" [templateRef]="tabItem"></tab-panel>
	</ng-container>
</bfa-tabs>
